






















import Vue from 'vue';
import { mapState as mapRootState } from 'vuex';
export default Vue.extend({
    props: {
        value: {
            type: Object,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    data: function() {
        return {
            picked: this.value || this.options[0],
        };
    },
    computed: {
        ...mapRootState(['portalBranding']),
    },
    watch: {
        picked() {
            this.$emit('input', this.picked);
        },
    },
});
